// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__n0GzD","cross":"Popup_cross__vVTcn","shake":"Popup_shake__WxCJn","thanking":"Popup_thanking__kX6uh","innerbox":"Popup_innerbox__RjPZk"};